const MainSelect = (props) => {
    return (
        <div>
            <select
                className="form-control"
                name={props.name}
                onChange={props.onChange}
                value={props.value}
            >
                {props.children}
            </select>
            {/* {props.children} */}
        </div>
    )
}
export { MainSelect }